import React from 'react'

import Link from 'next/link'

import { User } from '~/api-definition/definition'
import {
  FacebookIcon,
  InstagramIcon,
  InstagramTreadsIcon,
  LitlinkIcon,
  TabelogIcon,
  TiktokIcon,
  TwitterIcon,
  YoutubeIcon,
} from '~/components/icons'
import {
  SocialAccountType,
  normalizeSocialAccountName,
  socialAccountNameUrl,
} from '~/libs/social_account'

export const SocialLink: React.FC<{
  type: SocialAccountType
  icon: React.FC<any>
  iconClassName?: string
  id: string
  maxIdLength: number
}> = (props) => {
  const id = normalizeSocialAccountName(props.type, props.id)
  const url = socialAccountNameUrl(props.type, id)
  return (
    <Link
      className="flex items-center pb-2 gap-x-2"
      href={url}
      target="_blank"
      rel="noopener"
    >
      <props.icon className={`fill-[#999] ${props.iconClassName}`} />
      <div className="text-[12px] text-[#999]">
        {id.length > props.maxIdLength
          ? id.slice(0, props.maxIdLength) + '...'
          : id}
      </div>
    </Link>
  )
}

export const SocialLinks: React.FC<{
  user: User
}> = (props) => {
  return (
    <>
      {props.user.instagramUserId &&
        SocialLink({
          type: 'instagram',
          icon: InstagramIcon,
          id: props.user.instagramUserId,
          maxIdLength: 15,
        })}
      {props.user.instagramUserId &&
        props.user.usingInstagramThreads &&
        SocialLink({
          type: 'instagramTreads',
          icon: InstagramTreadsIcon,
          id: props.user.instagramUserId,
          maxIdLength: 15,
        })}
      {props.user.facebookUserId &&
        SocialLink({
          type: 'facebook',
          icon: FacebookIcon,
          id: props.user.facebookUserId,
          maxIdLength: 15,
        })}
      {props.user.twitterUserId &&
        SocialLink({
          type: 'twitter',
          icon: TwitterIcon,
          id: props.user.twitterUserId,
          maxIdLength: 15,
        })}
      {props.user.tabelogUserId &&
        SocialLink({
          type: 'tabelog',
          icon: TabelogIcon,
          iconClassName: 'w-6',
          id: props.user.tabelogUserId,
          maxIdLength: 15,
        })}
      {props.user.youtubeChannelId &&
        SocialLink({
          type: 'youtube',
          icon: YoutubeIcon,
          id: props.user.youtubeChannelId,
          maxIdLength: 15,
        })}
      {props.user.tiktokUserId &&
        SocialLink({
          type: 'tiktok',
          icon: TiktokIcon,
          id: props.user.tiktokUserId,
          maxIdLength: 15,
        })}
      {props.user.litlinkUserId &&
        SocialLink({
          type: 'litlink',
          icon: LitlinkIcon,
          id: props.user.litlinkUserId,
          maxIdLength: 15,
        })}
    </>
  )
}
